// Libs
import { connect } from 'react-redux'

// Selectors
const mapStateToProps = (state, props) => {
  return {
    notScrollable: props.notScrollable,
  }
}

export default connect(mapStateToProps)
